document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-om-audio]').forEach(function (button) {
    var audio = button.parentElement.querySelector('[data-om-audio-element]');
    if (!audio) return;
    button.addEventListener('click', function () {
      if (audio.paused) {
        var promise = audio.play();
        if (promise && promise.then) promise.then(function () {
          button.classList.add('is-playing');
          var label = button.querySelector('[data-om-label]');
          if (label) label.textContent = 'Playing Om Chant';
          button.querySelector('.om-play-icon').textContent = 'Ⅱ';
        }).catch(function () {
          var label = button.querySelector('[data-om-label]');
          if (label) label.textContent = 'Check audio URL';
        });
      } else {
        audio.pause();
        audio.currentTime = 0;
        button.classList.remove('is-playing');
        var label = button.querySelector('[data-om-label]');
        if (label) label.textContent = 'Play Om Chant';
        button.querySelector('.om-play-icon').textContent = '▶';
      }
    });
    audio.addEventListener('ended', function () {
      button.classList.remove('is-playing');
      var label = button.querySelector('[data-om-label]');
      if (label) label.textContent = 'Play Om Chant';
      button.querySelector('.om-play-icon').textContent = '▶';
    });
  });
  var toggle = document.querySelector('[data-menu-toggle]');
  if (toggle) {
    toggle.addEventListener('click', function () {
      var nav = document.querySelector('.desktop-nav');
      if (!nav) return;
      nav.style.display = nav.style.display === 'flex' ? 'none' : 'flex';
      nav.style.position = 'absolute';
      nav.style.top = '100%';
      nav.style.left = '0';
      nav.style.right = '0';
      nav.style.padding = '18px 6%';
      nav.style.background = '#fcf8f0';
      nav.style.flexDirection = 'column';
      nav.style.alignItems = 'flex-start';
      nav.style.borderTop = '1px solid #ddc9ad';
    });
  }
});